export function DocumentsTab() {
  return (
    <div
      className="bg-white rounded-lg shadow p-6"
      data-test-id="documents-tab"
    >
      <h2 className="text-xl font-semibold mb-4">Documents</h2>
      <p className="text-gray-600">No documents available for this loan.</p>
    </div>
  );
}
